export const BANKID_QUERY_PARAMS = [
	"sessionId",
	"failedAuth",
	"errorCode",
	"errorDetails",
	"relayState",
	"sessionStatus",
] as const;

export type BankIdQueryParam = (typeof BANKID_QUERY_PARAMS)[number];

export const BankIdStorageKey = {
	RegistrationSessionId: "bankIdRegistrationSessionId",
	AdditionalUserInfo: "additionalBankIdUserInfo",
	PrefilledFieldsDisabled: "arePrefilledFieldsDisabled",
	StepUpSnapshot: "bankIdStepUp",
} as const;
